// Tabs/TabConfig.ts
export const TABS = [
    { name: 'plants_varieties', label: 'Plants / Varieties', icon: 'plants_varieties' },
    { name: 'compounds', label: 'Compounds', icon: 'compounds' },
    { name: 'pharmacology', label: 'Pharmacology', icon: 'pharmacology' },
    { name: 'toxicity', label: 'Toxicity', icon: 'toxicity' },
    { name: 'disorders_diceases', label: 'Disorders / Diseases', icon: 'disorders_diceases' },
    { name: 'quality_safety', label: 'Quality & Safety', icon: 'quality_safety' },
    { name: 'products', label: 'Products', icon: 'products' },
    { name: 'regulations', label: 'Regulations', icon: 'regulations' },
    { name: 'patents', label: 'Patents', icon: 'patents' },
    { name: 'references', label: 'References', icon: 'references' },
    { name: 'baskets', label: 'Baskets', icon: 'baskets' },
    { name: 'loggers', label: 'Loggers / Audit Trail', icon: 'loggers' }
];
